const getSelectedStatusFilters = state => state.statuses;

export default getSelectedStatusFilters;
